import type { JSX } from "preact";

type CounterProps = {
  value: number;
  minDigits?: number;
  class?: string;
  style?: JSX.CSSProperties;
};

/** Numeric readout where every increase rolls per-digit instead of just swapping. */
export function Counter({ value, minDigits = 1, class: className, style }: CounterProps) {
  const str = Math.max(0, Math.round(value)).toString().padStart(minDigits, "0");
  const digits = str.split("").map(Number);
  return (
    <span class={["counter", className].filter(Boolean).join(" ")} style={style}>
      {digits.map((d, i) => (
        <DigitRoll key={digits.length - i} digit={d} />
      ))}
    </span>
  );
}

function DigitRoll({ digit }: { digit: number }) {
  return (
    <span class="counter-digit">
      <span class="counter-digit-inner" style={{ transform: `translateY(-${digit * 1.2}em)` }}>
        {Array.from({ length: 10 }, (_, n) => (
          <span key={n} style={{ display: "block", height: "1.2em", lineHeight: "1.2em" }}>
            {n}
          </span>
        ))}
      </span>
    </span>
  );
}
